import { reactive } from 'vue';

type StateType = {
  settingsOpened: boolean;
  mobileNavOpened: boolean;
};

const state = reactive<StateType>({
  settingsOpened: false,
  mobileNavOpened: false,
});

export default state;
